import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, apiErrorMessage } from "@/lib/api";

export default function AdminCategories() {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");

  const load = () => api.get("/categories").then(({ data }) => setCategories(data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post("/categories", { name, order: categories.length });
      setName("");
      load();
      toast.success("Категорията е създадена");
    } catch (err) {
      toast.error(apiErrorMessage(err));
    }
  };

  const update = async (cat, field, value) => {
    try {
      await api.put(`/categories/${cat.id}`, { ...cat, [field]: value });
      load();
    } catch (err) {
      toast.error(apiErrorMessage(err));
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Изтриване на категорията?")) return;
    await api.delete(`/categories/${id}`);
    load();
  };

  return (
    <div data-testid="admin-categories-page">
      <h1 className="font-serif text-3xl font-bold text-[#1A1A1A] mb-8">Категории</h1>
      <form onSubmit={create} className="flex gap-3 mb-8">
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Нова категория" data-testid="admin-category-name-input" />
        <Button type="submit" className="bg-[#A6192E] hover:bg-[#8C1123]" data-testid="admin-category-create-btn">Добави</Button>
      </form>
      <div className="bg-white border border-[#E2E8F0] divide-y divide-[#E2E8F0]" data-testid="admin-category-table">
        {categories.map((c) => (
          <div key={c.id} className="flex items-center gap-4 px-4 py-3" data-testid={`admin-category-row-${c.slug}`}>
            <Input defaultValue={c.name} onBlur={(e) => update(c, "name", e.target.value)} className="flex-1" />
            <Input defaultValue={c.slug} onBlur={(e) => update(c, "slug", e.target.value)} className="w-48 text-[#718096]" />
            <Input type="number" defaultValue={c.order} onBlur={(e) => update(c, "order", Number(e.target.value))} className="w-20" />
            <Button variant="outline" onClick={() => remove(c.id)} className="text-red-600 border-red-200" data-testid={`admin-category-delete-${c.slug}`}>Изтрий</Button>
          </div>
        ))}
      </div>
    </div>
  );
}
